import React, { useState } from "react";
import { Modal, Input, Button, message } from "antd";
import {
  get_opening_balance,
  set_opening_balance,
} from "../../../../Controllers/Registry";

const OpeningBalanceModal = ({ onRefetch, visible, onClose }) => {
  const [balance, setBalance] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (balance === "" || isNaN(balance)) {
      message.error("Please enter a valid amount");
      return;
    }

    setLoading(true);
    try {
      const response = await set_opening_balance(parseFloat(balance));
      if (response.status) {
        onRefetch();
        onClose();
        message.success("Opening balance set successfully");
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Error setting opening balance");
    }
    setLoading(false);
  };

  const formatDecimal = (value) => {
    if (value === "") return "";

    let cleaned = value.replace(/[^0-9.]/g, "");

    const parts = cleaned.split(".");
    if (parts.length > 2) {
      cleaned = parts[0] + "." + parts.slice(1).join("");
    }

    let [integer, decimal] = cleaned.split(".");

    if (integer) {
      integer = integer.slice(0, 15);
    }

    if (decimal) {
      decimal = decimal.slice(0, 5);
    }

    return decimal !== undefined ? `${integer}.${decimal}` : integer;
  };

  return (
    <Modal
      title="Set Opening Balance"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
          className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
        >
          Set Opening Balance
        </Button>,
      ]}
      closable={false}
      maskClosable={false}
    >
      <div className="mb-4">
        <p>Please enter your opening balance for today's registry:</p>
        <Input
          type="number"
          value={balance}
          onChange={(e) => {
            const val = e.target.value;
            const Formattedval = formatDecimal(val);
            setBalance(Formattedval === "" ? "" : Formattedval);
          }}
          onBlur={() => {
            if (balance === "") setBalance("0");
          }}
          placeholder="Enter opening balance"
          style={{ marginTop: "10px" }}
          onKeyDown={(e) => {
            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
              e.preventDefault();
            }
          }}
          onWheel={(e) => {
            e.target.blur();
          }}
        />
      </div>
    </Modal>
  );
};

export default OpeningBalanceModal;
